/* Lightbox for the "Real customer photos" section.
   No dependencies: if this script fails the photos still render as a scrollable row. */
class CustomerPhotos extends HTMLElement {
  connectedCallback() {
    if (this.dataset.lightbox !== 'true') return;

    this.buttons = Array.from(this.querySelectorAll('.customer-photos__button'));
    if (!this.buttons.length) return;

    this.photos = this.buttons.map((button) => ({
      src: button.dataset.full,
      caption: button.dataset.caption || '',
    }));

    this.buttons.forEach((button, index) => {
      button.addEventListener('click', () => this.open(index));
    });
  }

  build() {
    if (this.dialog) return;

    const dialog = document.createElement('dialog');
    dialog.className = 'customer-photos__dialog';
    dialog.dataset.single = String(this.photos.length < 2);
    dialog.innerHTML = [
      '<div class="customer-photos__dialog-inner">',
      '<button type="button" class="customer-photos__dialog-close" aria-label="Close">&#10005;</button>',
      '<button type="button" class="customer-photos__dialog-nav customer-photos__dialog-nav--prev" aria-label="Previous photo">&#8249;</button>',
      '<figure class="customer-photos__dialog-figure">',
      '<img alt="">',
      '<figcaption></figcaption>',
      '</figure>',
      '<button type="button" class="customer-photos__dialog-nav customer-photos__dialog-nav--next" aria-label="Next photo">&#8250;</button>',
      '</div>',
    ].join('');

    this.dialog = dialog;
    this.dialogImage = dialog.querySelector('img');
    this.dialogCaption = dialog.querySelector('figcaption');

    dialog.querySelector('.customer-photos__dialog-close').addEventListener('click', () => this.close());
    dialog.querySelector('.customer-photos__dialog-nav--prev').addEventListener('click', () => this.step(-1));
    dialog.querySelector('.customer-photos__dialog-nav--next').addEventListener('click', () => this.step(1));

    // Click on the backdrop area (the dialog itself, not the figure) closes.
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.classList.contains('customer-photos__dialog-inner')) {
        this.close();
      }
    });

    dialog.addEventListener('keydown', (event) => {
      // Escape is handled explicitly: other scripts on this store swallow the
      // dialog's native cancel event, so we can't rely on the browser default.
      if (event.key === 'Escape' || event.key === 'Esc') {
        event.preventDefault();
        event.stopPropagation();
        this.close();
      } else if (event.key === 'ArrowRight') {
        event.preventDefault();
        this.step(1);
      } else if (event.key === 'ArrowLeft') {
        event.preventDefault();
        this.step(-1);
      }
    });

    // Every close route (button, backdrop, Escape) ends in the native close event.
    dialog.addEventListener('close', () => this.onClose());

    this.appendChild(dialog);
  }

  render(index) {
    const photo = this.photos[index];
    this.currentIndex = index;
    this.dialogImage.src = photo.src;
    this.dialogImage.alt = photo.caption;
    this.dialogCaption.textContent = photo.caption;
  }

  step(direction) {
    const count = this.photos.length;
    this.render((this.currentIndex + direction + count) % count);
  }

  open(index) {
    this.build();
    this.openedBy = this.buttons[index];
    this.render(index);
    document.body.classList.add('customer-photos-dialog-open');
    if (typeof this.dialog.showModal === 'function') {
      this.dialog.showModal();
    } else {
      this.dialog.setAttribute('open', '');
    }
  }

  close() {
    if (typeof this.dialog.close === 'function') {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
      this.onClose();
    }
  }

  onClose() {
    document.body.classList.remove('customer-photos-dialog-open');
    if (this.openedBy) this.openedBy.focus();
  }
}

if (!customElements.get('customer-photos')) {
  customElements.define('customer-photos', CustomerPhotos);
}
